module.exports = __webpack_public_path__ + "img/icon_miyou.671cb787.png";